class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/lemonmax/campaign'
			}
		};
	}
}

export default new APIS();
